import React from "react";

const EligibilityStatus = ({ eligibility }) => {
  if (!eligibility) return null;

  const getStatusClass = () => {
    if (!eligibility.hasEligibility) return "no-eligibility";
    if (eligibility.alreadyParticipated) return "participated";
    if (eligibility.canParticipate) return "eligible";
    return "";
  };

  const getStatusIcon = () => {
    if (!eligibility.hasEligibility) return "❌";
    if (eligibility.alreadyParticipated) return "✅";
    if (eligibility.canParticipate) return "🎫";
    return "❓";
  };

  const getStatusText = () => {
    if (!eligibility.hasEligibility) return "참가 자격 없음";
    if (eligibility.alreadyParticipated) return "참여 완료";
    if (eligibility.canParticipate) return "참가 자격 있음";
    return "상태 확인 중";
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className={`newyear-eligibility-status ${getStatusClass()}`}>
      <div className="eligibility-status__header">
        <span className="eligibility-status__icon">{getStatusIcon()}</span>
        <span className="eligibility-status__text">{getStatusText()}</span>
      </div>
      {eligibility.grantedAt && (
        <div className="eligibility-status__info">
          <span className="eligibility-status__label">자격 부여:</span>
          <span className="eligibility-status__value">
            {formatDate(eligibility.grantedAt)}
          </span>
        </div>
      )}
      {eligibility.participatedAt && (
        <div className="eligibility-status__info">
          <span className="eligibility-status__label">참여 일시:</span>
          <span className="eligibility-status__value">
            {formatDate(eligibility.participatedAt)}
          </span>
        </div>
      )}
    </div>
  );
};

export default EligibilityStatus;
